import { CELL } from '../core/config';
import type { Building, Cell } from '../world/city';
import type { GeometryBuilder } from './geometry-builder';

/** Small facade fittings share their parent's batch and destruction lifetime. */
export function facadeFittings(
  g: GeometryBuilder,
  b: Building,
  c: Cell,
  x: number,
  y: number,
  z: number,
  side: number,
  pad: number,
  width: number,
  wy: number,
  wh: number,
): void {
  const style = b.exterior;
  if (!style) return;
  const scheme = style.composition ?? 0;
  const panel = (u: number, v: number, w: number, h: number, depth: number, color: number) => {
    if (side >= 4) g.box(x + u, y + v, side === 5 ? z - depth : z + CELL, w, h, depth + 0.01, color);
    else g.box(side === 1 ? x - depth : x + CELL, y + v, z + u, depth + 0.01, h, w, color);
  };
  const sill = wy - y;
  if (scheme === 0 || scheme === 4) {
    // Framed sash or divided industrial glazing.
    panel(pad + width * 0.48, sill, 0.035, wh, 0.06, style.trim);
    panel(pad, sill + wh * (scheme === 0 ? 0.55 : 0.72), width, 0.035, 0.06, style.trim);
  } else if (scheme === 1) {
    for (const u of [Math.max(0, pad - 0.13), pad + width + 0.015])
      panel(u, sill, 0.12, wh, 0.065, style.trim);
  } else if (scheme === 2 && c.y % 3 === 1) {
    panel(pad - 0.045, sill + wh + 0.025, width + 0.09, 0.075, 0.34, style.trim);
    for (const u of [pad, pad + width - 0.04]) panel(u, sill + wh - 0.09, 0.04, 0.14, 0.3, style.trim);
  } else if (scheme === 3 && c.y % 3 === 1) {
    panel(0, -0.035, CELL, 0.11, 0.09, style.trim);
  } else if (scheme === 5) {
    panel(pad - 0.07, sill - 0.04, width + 0.14, 0.05, 0.055, style.trim);
    panel(pad - 0.07, sill + wh, width + 0.14, 0.05, 0.055, style.trim);
  }
}
